<script>
	import {push, replace} from "svelte-spa-router";
	import {docs,logueo} from "../store.js";
	import {onMount,beforeUpdate} from "svelte";
	import Controlador from "../controlador.svelte";
	let c;
	let locales = [];
	let productos = [];
	let producto;
	let stock = {};
	let costo = undefined;
	let precio = undefined;
	onMount(()=>{
		locales = $docs.filter((el)=>el._id.includes("local:"));
		if (!$logueo){
			replace('/');
		}
	})
	beforeUpdate(()=>{
		if (productos && filtro != ""){
			productos = $docs.filter((el)=> el._id.includes("deposito:")).filter((el)=>el.tipo == "Producto").filter((el)=>el.nombre.toLowerCase().includes(filtro.toLowerCase()));
		}
	})
	function elegir(p){
		producto = p;
		filtro = "";
	}
	function cancelar(){
		producto = undefined;
	}
	let filtro = "";
	async function agregar(){
		console.log(producto);
		console.log(stock);
		locales.forEach((local)=>{
			if (local.stock[producto._id]){
				local.stock[producto._id] = local.stock[producto._id] + stock[local._id];
			} else {
				local.stock[producto._id] = stock[local._id];
			}
		})
		if (costo !== undefined){
			producto.costo = costo;
		}
		if (precio !== undefined){
			producto.precio = precio;
		}
		if (costo !== undefined || precio !== undefined){
			locales.push(producto);
		}
		console.log(locales);
		c.cargarStock(locales);
		push('/deposito/-1');
	}
</script>
<Controlador bind:this={c} />
<div class="w-full p-4 flex flex-col items-center justify-start">
	<a href={`#/deposito/-1`} class="w-full m-2 p-2 bg-red-500 text-white rounded shadow hover:bg-red-300 cursor-pointer">
		<i class="ri-arrow-left-line" />
		Volver
	</a>	
	{#if producto == undefined}
		<input bind:value={filtro} type="text" placeholder="Filtro" class="w-full bg-white m-2 p-2 rounded shadow" />
		{#if filtro != ""}
			<div class="w-full flex flex-col items-center justify-start">
				{#each productos as p}
					<div class="w-full m-2 p-2 border-b border-gray-400 cursor-pointer hover:bg-white" on:click={()=>{elegir(p)}}>
						{p.nombre}
					</div>
				{/each}
			</div>
		{/if}
	{:else}
		<div class="w-full flex items-center justify-center bg-white rounded shadow">
			<div class="w-full flex items-center m-2">{producto.nombre}</div>
			<div class="flex items-center justify-center">
				<button on:click={cancelar} class="m-2 p-2 bg-red-500 text-white rounded shadow flex items-center jusfify-center">
					<i class="ri-close-line" />
				</button>
			</div>
		</div>
		{#each locales as l}
			<div class="m-2 p-2 w-full flex items-center justify-center">
				<p class="w-full font-bold flex items-center justify-end">{l.nombre}</p>
				<input bind:value={stock[l._id]} type="number" placeholder="Cantidad" class="bg-white m-2 p-2 rounded shadow" />
			</div>
		{/each}
		<input bind:value={costo} type="number" placeholder="Costo" class="w-full bg-white m-2 p-2 rounded shadow" />
		<input bind:value={precio} type="number" placeholder="Precio" class="w-full bg-white m-2 p-2 rounded shadow" />
		<button on:click={agregar} class="w-full m-2 p-2 bg-red-500 text-white rounded shadow hover:bg-red-300 cursor-pointer">
			<i class="ri-add-line" />
			Agregar
		</button>
	{/if}

</div>
